import type { VisitorCustomFieldConfig } from 'graphql-query-contracts';

import type { CustomFieldRendererField } from 'domains/visitorManagement/feature/components/CustomFieldsSection/customField.types';

export function selectEnabledCustomFieldsForInvite(
  allConfigs: readonly VisitorCustomFieldConfig[],
  customFieldIds: readonly string[]
): CustomFieldRendererField[] {
  if (!customFieldIds.length || !allConfigs.length) {
    return [];
  }

  const configById = new Map(allConfigs.map(c => [c.id, c]));

  return customFieldIds
    .map(id => configById.get(id))
    .filter((c): c is VisitorCustomFieldConfig => c?.isEnabled === true);
}
